import { Navigate, useLocation } from 'react-router-dom';

// helpers
// hooks
import { useUser } from '../hooks';
import { AuthService } from "_services/auth.service";

type PrivateRouteProps = {
    component: React.ComponentType;
    roles?: string;
};


const LOGIN = '/admin/login';
const TWO_FACTOR = '/admin/two-factor';
const COURT_SELECT = '/admin/court-select';

const PrivateRoute = ({ component: RouteComponent, roles, ...rest }: PrivateRouteProps) => {
    let location = useLocation();

    if (!AuthService.isLoggedIn()) {
        return <Navigate to={LOGIN} state={{ from: location }} replace />;
    }

    if (AuthService.requiresTwoFactor && AuthService.isLoggedIn()) {
        return <Navigate to={TWO_FACTOR} state={{ from: location }} replace />;
    }

    if (AuthService.isLoggedIn() && AuthService.$shouldSelectCourt.$ && location.pathname !== COURT_SELECT) {
        return <Navigate to={COURT_SELECT} state={{ from: location }} replace />;
    }

    return <RouteComponent />;
};

export default PrivateRoute;
